import React, { useEffect, useState } from "react";
import {
  Grid,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Typography,
  Box,
  Paper,
  Button,
  Autocomplete,
  Input,
  List,
  ListItem,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import CloseIcon from "@mui/icons-material/Close";
import { DatePicker, TimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { setLoading } from "../../store/CommonSlice";
import { CustomMessage } from "../../const/Spinner";
import { useDispatch, useSelector } from "react-redux";
import { getCostAllocationList, getCountryAssetMasterDataList, getCountryByProjectId, getLocalStoreByCountryId, getProjectByRegionId, getProjectMasterDataList, getRegionByCountryId, getStatusMasterDataList, getSupplierMasterDataList, getTransporterMasterDataList, getTransportMasterDataList, saveAssetOwner, saveLogistics } from "../../api/Services/masterServie";
import { enqueueSnackbar } from "notistack";
import { DropdownChangeEvent } from "primereact/dropdown";
import { CostAllocationType, CountryFromMaster, CountryMaster, FormValues, ProjectMaster, RegionMaster, StatusMaster, TransporterMaster, TransportMaster } from "../../types/assetTypes";
import { getAssetByIdData, uploadFiles } from "../../api/Services/assetServices";
import { getLogisticsByIdData } from "../../api/Services/logisticsService";
import { FILE_DOWNLOAD_PREVIEW, PAGESEND } from "../../api/endpoint";
import { RootState } from "../../store/Reduxstore";

interface CreateLogisticsProps {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  logisticsId: number | null;
  setLogisticsId: React.Dispatch<React.SetStateAction<number | null>>;  
  getListOfSelectedProducts: () => void;
  selectedValue: number | null;
 
}
const CreateIndent: React.FC<CreateLogisticsProps> = ({
  setOpen,
  logisticsId,
  setLogisticsId, 
  selectedValue, 
  getListOfSelectedProducts,
  
}) => 
  {const dispatch = useDispatch();
  // Log the logisticsId before formValues
  console.log("Initial logisticsId:", logisticsId);
  const [formValues, setFormValues] = React.useState<FormValues>({
    title: "",
    logisticsId: 0,
    dateOfDispatch: null,
    fromTime: null,
    fromProjectId: 0,
    fromProjectName: "",
    fromSupplierId: 0,
    fromSupplierName: "",
    costAllocationId: 0,
    costAllocationName: "",
    attachments: [],
    toProjectId: 0,
    toProjectName: "",
    toSupplierId: 0,
    toSupplierName: "",
    fromCountryName: "",
    fromCurrentLocationId: 0,
    costAllocationDetails: "",
    fromRegionId: 0,
    fromRegionName: "",    
    dateOfArrival: null,
    toTime: null,
    toCountryName: "",
    toCurrentLocationId: 0,
    toRegionId: 0,
    toRegionName: "",
    transporterId: 0,
    transporterName: "",
    itemDescription: "",
    transportId: 0,
    transportName: "",    
    transportDetails: "",
    statusId: 0,
    statusInfo: "",
    others1: "",
    others2: "",
    others3: "",
    comments: "",
  });

  console.log("Id:", logisticsId);

    const handleFileUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
      const fileList = event.target.files;
      if (!fileList || fileList.length === 0) {
          CustomMessage("No file selected", 'error', enqueueSnackbar);
          return;
      }
      const fileArray = Array.from(fileList); // Convert FileList to an array
  
      dispatch(setLoading(true)); // Set loading before upload starts
  
      try {
          const uploadPromises = fileArray.map(async (file) => {
              if (!file){
                CustomMessage("file not found",'error',enqueueSnackbar);
                return;
              };
              const data = new FormData();
              data.append('file', file); // Ensure the key matches backend expectations       
  
              const response = await uploadFiles(data);
              if (response.status.code === 201) {
                // Update formData with the uploaded files
                setFormValues((prev) => ({
                  ...prev,
                  attachments: Array.isArray(prev.attachments)
                    ? [...prev.attachments, { ...response.data }]
                    : [{ ...response.data }]
                }));
                return response.data;
              } else {
                CustomMessage(`Upload failed with status: ${response.status.code}`, 'error', enqueueSnackbar);
                throw new Error(`Upload failed with status: ${response.status.code}`);
              }
          });
  
          const uploadedFiles = await Promise.all(uploadPromises); // Wait for all uploads to complete
          CustomMessage("All files uploaded successfully", 'success', enqueueSnackbar);
  
      } catch (error: any) {
        CustomMessage(`File upload error: ${error.message}`, 'error', enqueueSnackbar);
      } finally {
        dispatch(setLoading(false)); // Set loading to false after all uploads finish
      }
    };

    const removeFile = (index: number) => {
    setFormValues((prev) => ({
      ...prev,
      attachments: prev.attachments.filter((_, i) => i !== index),
    }));
    };

  useEffect(() => {
    if (logisticsId !== null && logisticsId !== 0) {
      getLogisticsDataById();
    }
  }, [logisticsId]);
  
  const getLogisticsDataById = async () => {
    if (logisticsId === null || logisticsId === 0) {
      CustomMessage("Indent ID not selected", "error", enqueueSnackbar);
      return;
    }
  
    dispatch(setLoading(true));
    try {
      const response = await getLogisticsByIdData(logisticsId);
  
      if (response.data !== null) {
        const data = response.data;
  
        setFormValues((prev) => ({
          ...prev,
          ...data,
          dateOfDispatch: data.dateOfDispatch ? dayjs(data.dateOfDispatch) : null,
          dateOfArrival: data.dateOfArrival ? dayjs(data.dateOfArrival) : null,
          fromTime: data.fromTime ? dayjs(data.fromTime) : null,
          toTime: data.toTime ? dayjs(data.toTime) : null,
        }));
  
        if (data.fromCurrentLocationId) {
          getFromRegionList(Number(data.fromCurrentLocationId));
        }
  
        if (data.toCurrentLocationId) {
          getToRegionList(Number(data.toCurrentLocationId));
        }

        if (data.fromRegionId){
          getFromProjectList(Number(data.fromRegionId));
        }

        if (data.toRegionId){
          getToProjectList(Number(data.fromRegionId));
        }
      } else {
        //CustomMessage("No data found", "error", enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error?.message || "Something went wrong", "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handleChange = (name: string, value: any) => {
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };  

   const [fromCountryName, setFromCountryName] = useState<
   { label: string; value: string | null }[]
   >([]);

   const [transporter, setTransporter] = useState<
   { label: string; value: string | null }[]
   >([]);

   const [costAllocation, setCostAllocation] = useState<
   { label: string; value: string | null }[]
   >([]);

     const [fromSupplier, setFromSupplier] = useState<
   { label: string; value: string | null }[]
   >([]);

   const [toCountryName, setToCountryName] = useState<
   { label: string; value: string | null }[]
   >([]);

   const [toSupplier, setToSupplier] = useState<
   { label: string; value: string | null }[]
   >([]);

  const [fromRegions, setfromRegions] = useState<
    { label: string; value: string | null }[]
  >([]);

  const [toRegions, setToRegions] = useState<
  { label: string; value: string | null }[]
  >([]);

  const [fromproject, setFromProjects] = useState<
  { label: string; value: string | null}[]
  >([]);

  const [toproject, setToProjects] = useState<
  { label: string; value: string | null}[]
  >([]);

  console.log("fromproject:", fromproject);
  console.log("toproject:", toproject);

  const [status, setStatus] = useState<
  { label: string; value: string | null }[]
  >([]);

  const [transport, setTransport] = useState<
  { label: string; value: string | null }[]
  >([]);
   
    
  useEffect(() => {
    if (status.length === 0) getStatusList(1, PAGESEND);
  }, [status]);  

  useEffect(() => {
    if (transport.length === 0) getTransportList(1, PAGESEND);
  }, [transport]); 

  useEffect(() => {
    if (transporter.length === 0) getTransporterList(1, PAGESEND);
  }, [transporter]); 

   useEffect(() => {
    if (fromCountryName.length === 0) getFromCountryList(1, PAGESEND);
  }, [fromCountryName]); 

  useEffect(() => {
    if (toCountryName.length === 0) getToCountryList(1, PAGESEND);
  }, [toCountryName]);
  
  useEffect(() => {
    if (fromSupplier.length === 0) getFromSupplierList(1, PAGESEND);
  }, [fromSupplier]); 

  useEffect(() => {
    if (toSupplier.length === 0) getToSupplierList(1, PAGESEND);
  }, [toSupplier]); 

  useEffect(() => {
    if (costAllocation.length === 0) getCostAllocationnList(1, PAGESEND);
  }, [costAllocation]); 

const getFromCountryList = async (page: number, rows: number) => {
  dispatch(setLoading(true));
  try {
    const { data, status } = await getCountryAssetMasterDataList(
      page,
      rows,
      { currentLocationId: { value: "", matchMode: "startsWith" } }
    );

    if (status.code === 200 && data?.length > 0) {
      const updatedData: { label: string; value: string | null }[] = data.map(
        (val: { currentLocationId: number | string; countryName: string }) => ({
          value: String(val.currentLocationId), // Ensure it's a string
          label: val.countryName ?? "",          // Ensure it's a string
        })
      );

      updatedData.unshift({ label: "--Select--", value: null }); // Accept null here
      setFromCountryName(updatedData);
      console.log("Mapped location data:", updatedData);
    }
  } catch (error: any) {
    CustomMessage(error?.message, "error", enqueueSnackbar);
  } finally {
    dispatch(setLoading(false));
  }
};


  const getToCountryList = async (page: number, rows: number) => {
  dispatch(setLoading(true));
  try {
    const { data, status } = await getCountryAssetMasterDataList(
      page,
      rows,
      { currentLocationId: { value: "", matchMode: "startsWith" } }
    );

    if (status.code === 200 && data?.length > 0) {
      const updatedData: { label: string; value: string | null }[] = data.map(
        (val: { currentLocationId: number | string; countryName: string }) => ({
          value: String(val.currentLocationId),
          label: val.countryName ?? "",
        })
      );

      updatedData.unshift({ label: "--Select--", value: null }); // Support null value
      setToCountryName(updatedData);
      console.log("Mapped location data:", updatedData);
    }
  } catch (error: any) {
    CustomMessage(error?.message, "error", enqueueSnackbar);
  } finally {
    dispatch(setLoading(false));
  }
};

const getFromSupplierList = async (page: number, rows: number) => {
  dispatch(setLoading(true));
  try {
    const { data, status } = await getSupplierMasterDataList(
      page,
      rows,
      { supplierId: { value: "", matchMode: "startsWith" } }
    );

    if (status.code === 200 && data?.length > 0) {
      const updatedData: { label: string; value: string | null }[] = data.map(
        (val: { supplierId: number | string; supplierName: string }) => ({
          value: String(val.supplierId), // Ensure it's a string
          label: val.supplierName ?? "",          // Ensure it's a string
        })
      );

      updatedData.unshift({ label: "--Select--", value: null }); // Accept null here
      setFromSupplier(updatedData);
      console.log("Mapped location data:", updatedData);
    }
  } catch (error: any) {
    CustomMessage(error?.message, "error", enqueueSnackbar);
  } finally {
    dispatch(setLoading(false));
  }
};

const getToSupplierList = async (page: number, rows: number) => {
  dispatch(setLoading(true));
  try {
    const { data, status } = await getSupplierMasterDataList(
      page,
      rows,
      { supplierId: { value: "", matchMode: "startsWith" } }
    );

    if (status.code === 200 && data?.length > 0) {
      const updatedData: { label: string; value: string | null }[] = data.map(
        (val: { supplierId: number | string; supplierName: string }) => ({
          value: String(val.supplierId), // Ensure it's a string
          label: val.supplierName ?? "",          // Ensure it's a string
        })
      );

      updatedData.unshift({ label: "--Select--", value: null }); // Accept null here
      setToSupplier(updatedData);
      console.log("Mapped location data:", updatedData);
    }
  } catch (error: any) {
    CustomMessage(error?.message, "error", enqueueSnackbar);
  } finally {
    dispatch(setLoading(false));
  }
};

const getFromProjectList = async (regionId: number) => {
  dispatch(setLoading(true));
  try {
    const { data, status } = await getProjectByRegionId(regionId);

    if (status.code === 200 && Array.isArray(data?.projects) && data.projects.length > 0) {
      const updatedData: { label: string; value: string | null }[] = data.projects.map(
        (val: { projectId: number; projectName: string }) => ({
          value: String(val.projectId),
          label: val.projectName ?? "",
        })
      );
      updatedData.unshift({ label: "Select Project", value: null });
      setFromProjects(updatedData);
    } 
    // ✅ When projects array is empty
    else if (status.code === 200 && Array.isArray(data?.projects) && data.projects.length === 0) {
      setFromProjects([{ label: "Select Project", value: null }]);
    } 
    // ✅ Handle unexpected structure
    else {
      setFromProjects([{ label: "Select Project", value: null }]);
      setFormValues((prev) => ({
        ...prev,
        // projectId: "",
        projectName: ""
      }));
    }
  } catch (error: any) {
    CustomMessage(error?.message || "Failed to load projects", "error", enqueueSnackbar);
    setFromProjects([{ label: "Select Project", value: null }]);
  } finally {
    dispatch(setLoading(false));
  }
};

const getToProjectList = async (regionId: number) => {
  dispatch(setLoading(true));
  try {
    const { data, status } = await getProjectByRegionId(regionId);

    if (status.code === 200 && Array.isArray(data?.projects) && data.projects.length > 0) {
      const updatedData: { label: string; value: string | null }[] = data.projects.map(
        (val: { projectId: number; projectName: string }) => ({
          value: String(val.projectId),
          label: val.projectName ?? "",
        })
      );
      updatedData.unshift({ label: "Select Project", value: null });
      setToProjects(updatedData);
    } 
    // ✅ When projects array is empty
    else if (status.code === 200 && Array.isArray(data?.projects) && data.projects.length === 0) {
      setToProjects([{ label: "Select Project", value: null }]);
    } 
    // ✅ Handle unexpected structure
    else {
      setToProjects([{ label: "Select Project", value: null }]);
      setFormValues((prev) => ({
        ...prev,
        // projectId: "",
        projectName: ""
      }));
    }
  } catch (error: any) {
    CustomMessage(error?.message || "Failed to load projects", "error", enqueueSnackbar);
    setToProjects([{ label: "Select Project", value: null }]);
  } finally {
    dispatch(setLoading(false));
  }
};


//  const getProjectList = async (regionId: number) => {
//   dispatch(setLoading(true));
//   try {
//     const { data, status } = await getProjectByRegionId(regionId);

//     if (status.code === 200 && data.projects.length > 0) {
//       const updatedData: { label: string; value: string | null }[] = data.projects.map(
//         (val: { projectId: number; projectName: string }) => ({
//           value: String(val.projectId), // Ensure value is a string
//           label: val.projectName ?? "",
//         })
//       );

//       updatedData.unshift({ label: "--Select--", value: null }); // Default null option
//       setProjects(updatedData);
//     }
//      else {
//             // ✅ Set to empty array when no data or non-200 status
//             setProjects([]);
//         }
//     } catch (error: any) {
//         CustomMessage(error?.message || "Failed to load regions", "error", enqueueSnackbar);
//         // ✅ Also set to empty array in case of error
//         setProjects([]);
//   } finally {
//     dispatch(setLoading(false));
//   }
// };


  const getStatusList = async (page: number, rows: number) => {
    dispatch(setLoading(true));
    try {
      const { data, status } = await getStatusMasterDataList(page, rows,{projectId:{value:"",matchMode: "startsWith"}});
      if (status.code === 200 && data?.length > 0) {
        const updatedData: { label: string; value: string | null }[] = data.map((val) => ({
          value: val.statusId.toString(),
          label: val.statusInfo,
        }));
        updatedData.unshift({ label: "--Select--", value: null });
        setStatus(updatedData);
        
      } 
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const getTransportList = async (page: number, rows: number) => {
    dispatch(setLoading(true));
    try {
      const { data, status } = await getTransportMasterDataList(page, rows,{transportId:{value:"",matchMode: "startsWith"}});
      if (status.code === 200 && data?.length > 0) {
        const updatedData: { label: string; value: string | null }[] = data.map((val) => ({
          value: val.transportId.toString(),
          label: val.transportName,
        }));
        updatedData.unshift({ label: "--Select--", value: null });
        setTransport(updatedData);
        
      } 
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const getTransporterList = async (page: number, rows: number) => {
    dispatch(setLoading(true));
    try {
      const { data, status } = await getTransporterMasterDataList(page, rows,{transportId:{value:"",matchMode: "startsWith"}});
      if (status.code === 200 && data?.length > 0) {
        const updatedData: { label: string; value: string | null }[] = data.map((val) => ({
          value: val.transporterId.toString(),
          label: val.transporterName,
        }));
        updatedData.unshift({ label: "--Select--", value: null });
        setTransporter(updatedData);
        
      } 
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const getCostAllocationnList = async (page: number, rows: number) => {
    dispatch(setLoading(true));
    try {
      const { data, status } = await getCostAllocationList(page, rows,{transportId:{value:"",matchMode: "startsWith"}});
      if (status.code === 200 && data?.length > 0) {
        const updatedData: { label: string; value: string | null }[] = data.map((val) => ({
          value: val.costAllocationId.toString(),
          label: val.costAllocationName,
        }));
        updatedData.unshift({ label: "--Select--", value: null });
        setCostAllocation(updatedData);
        
      } 
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };

  
  
  const getFromRegionList = async (currentLocationId: number) => {
        dispatch(setLoading(true));
        try {
            const { data, status } = await getRegionByCountryId(currentLocationId);
    
            if (status.code === 200 && data?.regions?.length > 0) {
                const updatedData: { label: string; value: string | null }[] = data.regions.map(
                    (val: { regionId: number; regionName: string }) => ({
                        value: String(val.regionId), // Convert to string
                        label: val.regionName ?? "", // Ensure it's a string
                    })
                );
                updatedData.unshift({ label: "--Select--", value: null });
                setfromRegions(updatedData);
             } else {
            // ✅ Set to empty array when no data or non-200 status
            setfromRegions([]);
        }
    } catch (error: any) {
        CustomMessage(error?.message || "Failed to load regions", "error", enqueueSnackbar);
        // ✅ Also set to empty array in case of error
        setfromRegions([]);
        } finally {
            dispatch(setLoading(false));
        }
  };

  const getToRegionList = async (currentLocationId: number) => {
    dispatch(setLoading(true));
    try {
        const { data, status } = await getRegionByCountryId(currentLocationId);

        if (status.code === 200 && data?.regions?.length > 0) {
            const updatedData: { label: string; value: string | null }[] = data.regions.map(
                (val: { regionId: number; regionName: string }) => ({
                    value: String(val.regionId), // Convert to string
                    label: val.regionName ?? "", // Ensure it's a string
                })
            );
            updatedData.unshift({ label: "--Select--", value: null });
            setToRegions(updatedData);
        } else {
            // ✅ Set to empty array when no data or non-200 status
            setToRegions([]);
        }
    } catch (error: any) {
        CustomMessage(error?.message || "Failed to load regions", "error", enqueueSnackbar);
        // ✅ Also set to empty array in case of error
        setToRegions([]);
    } finally {
        dispatch(setLoading(false));
    }
};


const handleSelectFromCountryChange = (
  _event: any,
  newValue: { label: string; value: string | null } | null
) => {
  const updatedData: Partial<FormValues> = { ...formValues };

  if (newValue && newValue.value) {
    updatedData.fromCountryName = newValue.label;
    updatedData.fromCurrentLocationId = parseInt(newValue.value);
    // ✅ Fetch regions only if country is selected
    getFromRegionList(parseInt(newValue.value));
  } else {
    // ✅ Clear country & related region when country is removed
    updatedData.fromCountryName = '';
    updatedData.fromCurrentLocationId = 0;

    updatedData.fromRegionName = '';
    updatedData.fromRegionId = 0;

    setfromRegions([]); // ✅ Clear region dropdown list
  }

  console.log("info:", updatedData);
  setFormValues(updatedData as FormValues);
};


const handleSelectToCountryChange = (
  _event: any,
  newValue: { label: string; value: string | null } | null
) => {
  const updatedData: Partial<FormValues> = { ...formValues };

  if (newValue && newValue.value) {
    updatedData.toCountryName = newValue.label;
    updatedData.toCurrentLocationId = parseInt(newValue.value);
    getToRegionList(parseInt(newValue.value)); // fetch region list
  } else {
    // ❗ When user clears the selection, reset all relevant fields
    updatedData.toCountryName = '';
    updatedData.toCurrentLocationId = 0;

    updatedData.toRegionName = '';
    updatedData.toRegionId = 0;

    setToRegions([]); // clear the dropdown options for regions
  }

  console.log("info:", updatedData);
  setFormValues(updatedData as FormValues);
};


const handleSelectFromRegionChange = (
  _event: any,
  newValue: { label: string; value: string | null } | null
) => {
  const updatedData: Partial<FormValues> = { ...formValues };

  if (newValue && newValue.value) {
    updatedData.fromRegionName = newValue.label;
    updatedData.fromRegionId = parseInt(newValue.value);

    getFromProjectList(parseInt(newValue.value)); // fetch projects
  } else {
    // 🔁 Clear region & dependent project data
    updatedData.fromRegionName = '';
    updatedData.fromRegionId = 0;

    updatedData.fromProjectName = '';
    updatedData.fromProjectId = 0;

    setFromProjects([]); // ✅ clear the project list
  }

  console.log("info:", updatedData);
  setFormValues(updatedData as FormValues);
};


const handleSelectFromProjectChange = (
  _event: any,
  newValue: { label: string; value: string | null } | null
) => {
  const updatedData: Partial<FormValues> = { ...formValues };

  if (newValue && newValue.value) {
    updatedData.fromProjectName = newValue.label;
    updatedData.fromProjectId = parseInt(newValue.value);
  } else {
    updatedData.fromProjectName = '';
    updatedData.fromProjectId = 0; // Or 0, depending on your backend handling
  }

  console.log("info:", updatedData);
  setFormValues(updatedData as FormValues);
};

const handleSelectFromSupplierChange = (
  _event: any,
  newValue: { label: string; value: string | null } | null
) => {
  const updatedData: Partial<FormValues> = { ...formValues };

  if (newValue && newValue.value) {
    updatedData.fromSupplierName = newValue.label;
    updatedData.fromSupplierId = parseInt(newValue.value);
  } else {
    updatedData.fromSupplierName = '';
    updatedData.fromSupplierId = 0; // Or 0, based on how your backend expects it
  }

  console.log("info:", updatedData);

  setFormValues(updatedData as FormValues);
};


 const handleSelectToSupplierChange = (
  _event: any,
  newValue: { label: string; value: string | null } | null
) => {
  const updatedData: Partial<FormValues> = { ...formValues };

  if (newValue && newValue.value) {
    updatedData.toSupplierName = newValue.label;
    updatedData.toSupplierId = parseInt(newValue.value);
  } else {
    updatedData.toSupplierName = '';
    updatedData.toSupplierId = 0;
  }

  console.log("info:", updatedData);
  setFormValues(updatedData as FormValues);
};

  const handleSelectToProjectChange = (
  _event: any,
  newValue: { label: string; value: string | null } | null
) => {
  const updatedData: Partial<FormValues> = { ...formValues };

  if (newValue && newValue.value) {
    updatedData.toProjectName = newValue.label;
    updatedData.toProjectId = parseInt(newValue.value);
  } else {
    updatedData.toProjectName = '';
    updatedData.toProjectId = 0;
  }

  console.log("info:", updatedData);
  setFormValues(updatedData as FormValues);
};


  const handleSelectToRegionChange = (
  _event: any,
  newValue: { label: string; value: string | null } | null
) => {
  const updatedData: Partial<FormValues> = { ...formValues };

  if (newValue && newValue.value) {
    updatedData.toRegionName = newValue.label;
    updatedData.toRegionId = parseInt(newValue.value);
    getToProjectList(parseInt(newValue.value));
  } else {
    updatedData.toRegionName = '';
    updatedData.toRegionId = 0;

    updatedData.toProjectName = '';
    updatedData.toProjectId = 0;

    setToProjects([]); // clear project dropdown
  }

  console.log("info:", updatedData);
  setFormValues(updatedData as FormValues);
};
const handleSelectStatusChange = (
  e: DropdownChangeEvent | React.ChangeEvent<HTMLInputElement> | any,
  name: keyof StatusMaster,
  name2: keyof StatusMaster
) => {
  const updatedData: Partial<FormValues> = { ...formValues };

  const value = e?.target?.value;

  if (value) {
    (updatedData as any)[name] = value.label;
    (updatedData as any)[name2] = value.value;
  } else {
    (updatedData as any)[name] = '';
    (updatedData as any)[name2] = 0;
  }

  setFormValues(updatedData as FormValues);
  console.log("info:", updatedData);
};

  const handleSelectTransporterChange = (
    e: DropdownChangeEvent | React.ChangeEvent<HTMLInputElement> | any,
    name: keyof TransporterMaster,
    name2: keyof TransporterMaster
  ) => {
    const updatedData: Partial<FormValues> = { ...formValues };
  
    (updatedData as any)[name] = (e.target as { value: { label: string } }).value?.label || "";
    (updatedData as any)[name2] = (e.target as { value: { value: number } }).value?.value || 0;

  
    setFormValues(updatedData as FormValues);
    console.log("info:", updatedData);
 
  };

  const handleSelectCostAllocationChange = (
    e: DropdownChangeEvent | React.ChangeEvent<HTMLInputElement> | any,
    name: keyof CostAllocationType,
    name2: keyof CostAllocationType
  ) => {
    const updatedData: Partial<FormValues> = { ...formValues };
  
    (updatedData as any)[name] = (e.target as { value: { label: string } }).value?.label || "";
    (updatedData as any)[name2] = (e.target as { value: { value: number } }).value?.value || 0;

  
    setFormValues(updatedData as FormValues);
    console.log("info:", updatedData);
 
  };

    const handleSelectTransportChange = (
      e: DropdownChangeEvent | React.ChangeEvent<HTMLInputElement> | any,
      name: keyof TransportMaster,
      name2: keyof TransportMaster
    ) => {
      const updatedData: Partial<FormValues> = { ...formValues };
    
      (updatedData as any)[name] = (e.target as { value: { label: string } }).value?.label || "";
      (updatedData as any)[name2] = (e.target as { value: { value: number } }).value?.value || 0;
  
    
      setFormValues(updatedData as FormValues);


      console.log("info:",setFormValues); };

      const handleClear = () => {
        setFormValues({
            title: "",
            logisticsId: 0,
            dateOfDispatch: null,
            fromTime: null,
            fromCountryName: "",
            fromCurrentLocationId: 0,
            fromRegionId: 0,
            fromRegionName: "",
            fromProjectId: 0,
            fromProjectName: "",
            costAllocationId: 0,
            costAllocationName: "",
            costAllocationDetails: "",
            fromSupplierId: 0,
            fromSupplierName: "",
            dateOfArrival: null,
            toTime: null,
            toCountryName: "",
            toCurrentLocationId: 0,
            toRegionId: 0,
            toRegionName: "",
            toProjectId: 0,
            toProjectName: "",
            toSupplierId: 0,
            toSupplierName: "",
       
            itemDescription: "",
            transportId: 0,
            transportName: "",
            transportDetails: "",
            statusId: 0,
            statusInfo: "",
   
            others1: "",
            others2: "",
            others3: "",
            comments: "",
            transporterId: 0,
           transporterName: "",  
           attachments: []
        });
        setOpen(false);
      };

    const handleSubmit = async (event: React.FormEvent) => {
      event.preventDefault();
      dispatch(setLoading(true));

      try {
        let payload: FormValues = { ...formValues };

        // ✅ For new entry
        if (formValues.logisticsId === 0) {
          payload.userId = userDetails.userId ?? 0;
          payload.createdDate = new Date().toISOString();
          delete payload.lastUpdatedDate; // ensure no lastUpdatedDate is sent
        } 
        // ✅ For existing entry (update)
        else {
          payload.lastEditedUserId = userDetails.userId ?? 0;
          payload.lastUpdatedDate = new Date().toISOString();
          delete payload.createdDate; // ensure no createdDate is sent
        }

        const response = await saveLogistics(payload);
        const { status } = response;

        if (status.code === 200 || status.code === 201) {
          CustomMessage(status.message, "success", enqueueSnackbar);
          setOpen(false);
        } else {
          CustomMessage(status.message, "error", enqueueSnackbar);
        }
      } catch (error: any) {
        CustomMessage(error?.message, "error", enqueueSnackbar);
      } finally {
        dispatch(setLoading(false));
      }
    };

     

    // const handleSubmit = async (event: React.FormEvent) => {
    //   event.preventDefault();
    //   dispatch(setLoading(true));

    //   try {
    //     // Prepare payload
    //     let payload: FormValues = { ...formValues };

    //     // Only attach userId for POST requests
    //     if (formValues.logisticsId === 0) {
    //       payload.userId = userDetails.userId ?? 0;
    //     }

    //     if (formValues.logisticsId != 0) {
    //       payload.lastEditedUserId = userDetails.userId ?? 0;
    //     }

    //     const response = await saveLogistics(payload); // POST or PUT automatically handled
    //     const { status } = response;

    //     if (status.code === 200 || status.code === 201) {
    //       CustomMessage(status.message, "success", enqueueSnackbar);
    //       setOpen(false);
    //     } else {
    //       CustomMessage(status.message, "error", enqueueSnackbar);
    //     }
    //   } catch (error: any) {
    //     CustomMessage(error?.message, "error", enqueueSnackbar);
    //   } finally {
    //     dispatch(setLoading(false));
    //   }
    // };


      const userDetails = useSelector((state: RootState) => state.auth)

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <form>
      {/* <Paper elevation={3} sx={{ p: 3, mx: "auto", borderRadius: 1, backgroundColor: "#f9f9f9" }}> */}
      <div>
       <Box
          sx={{
            borderRadius: 2,
            boxShadow: 3,
            padding: 2,
            backgroundColor: "#FFFFFF",
            border: "12px solid #F9F9F9",
            marginBottom: 3,
          }}
          component="form"
        >
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <h5>Status</h5>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <h6>Title</h6>
              <TextField
                label=""
                fullWidth
                className="bg-white"
                value={formValues.title}
                onChange={(e) => handleChange("title", e.target.value)}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <h6>Status</h6>
              <FormControl fullWidth variant="outlined">
                <Autocomplete
                  aria-placeholder="status"
                  className="bg-white"
                  id="status"
                  value={{
                    label: formValues.statusInfo,
                    value: formValues.statusId?.toString() ?? "",
                  }}
                  options={status}
                  getOptionLabel={(option) => option.label}
                  onChange={(event, newValue) =>
                    handleSelectStatusChange(
                      { target: { value: newValue } },
                      "statusInfo",
                      "statusId"
                    )
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label=""
                      placeholder="status"
                    />
                  )}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value.value
                  }
                />
              </FormControl>
            </Grid>
          </Grid>
        </Box>

       <Box
          sx={{
            borderRadius: 2,
            boxShadow: 3,
            padding: 2,
            backgroundColor: "#FFFFFF",
            border: "12px solid #F9F9F9",
            marginBottom: 3,
          }}
          component="form"
        >
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <h5>From</h5>
            </Grid>

             <Grid item xs={12} sm={6} md={4}>
            <h6>Date of Dispatch</h6>
            <DatePicker
              label=""
              value={formValues.dateOfDispatch}
              className="bg-white"
              onChange={(date) => handleChange("dateOfDispatch", date)}
              slotProps={{ textField: { fullWidth: true } }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <h6>From Time</h6>
            <TimePicker
              label=""
              className="bg-white"
              value={formValues.fromTime}
              onChange={(time) => handleChange("fromTime", time)}
              views={["minutes", "seconds"]}
              format="mm:ss"
              ampm={false}
              slotProps={{ textField: { fullWidth: true } }}
            />
          </Grid>

          

          <Grid item xs={12} sm={6} md={4}>
          <h6>From Country</h6>
            <FormControl fullWidth variant="outlined">
              <Autocomplete
                aria-placeholder="from Country"
                className="bg-white"
                id="countryName"
                value={
                  fromCountryName.find(
                    (option) => option.value === formValues.fromCurrentLocationId?.toString()
                  ) || null
                }
                options={fromCountryName}
                getOptionLabel={(option) => option.label}
                onChange={(event, newValue) =>
                  handleSelectFromCountryChange(event, newValue)
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label=""
                    placeholder="from Country"
                  />
                )}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
          <h6>From Region</h6>
            <FormControl fullWidth variant="outlined">
              <Autocomplete
                aria-placeholder="from Region"
                className="bg-white"
                id="fromRegions"
                value={
                  fromRegions.find(
                    (option) => option.value === formValues.fromRegionId?.toString()
                  ) || null
                }
                options={fromRegions}
                getOptionLabel={(option) => option.label}
                onChange={(event, newValue) =>
                  handleSelectFromRegionChange(event, newValue)
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label=""
                    placeholder="from Region"
                  />
                )}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
          <h6>From Project</h6>
            <FormControl fullWidth variant="outlined">
              <Autocomplete
                aria-placeholder="Select a Project"
                className="bg-white"
                id="fromproject"
                value={{
                  label: formValues.fromProjectName ?? "", 
                  value: formValues.fromProjectId?.toString() ?? "", 
                }}
                options={fromproject}
                getOptionLabel={(option) => option.label}
                onChange={(event, newValue) =>
                  handleSelectFromProjectChange(event, newValue)
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    className="bg-white"
                    variant="outlined" // 👈 This gives the box style
                    label=""
                    placeholder="Select a project"
                  />
                )}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
          <h6>From Supplier</h6>
            <FormControl fullWidth variant="outlined">
              <Autocomplete
                aria-placeholder="Select a Supplier"
                className="bg-white"
                id="fromSupplier"
                value={
                  formValues.fromSupplierId
                    ? {
                        label: formValues.fromSupplierName,
                        value: formValues.fromSupplierId.toString()
                      }
                    : null
                }

                options={fromSupplier}
                getOptionLabel={(option) => option.label}
                onChange={(event, newValue) =>
                  handleSelectFromSupplierChange(event, newValue)
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    className="bg-white"
                    variant="outlined" // 👈 This gives the box style
                    label=""
                    placeholder="Select a supplier"
                  />
                )}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
              />
            </FormControl>
          </Grid>
           
          </Grid>
        </Box>

        <Box
          sx={{
            borderRadius: 2,
            boxShadow: 3,
            padding: 2,
            backgroundColor: "#FFFFFF",
            border: "12px solid #F9F9F9",
            marginBottom: 3,
          }}
          component="form"
        >
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <h5>To</h5>
            </Grid>

             <Grid item xs={12} md={4} sm={6}>
          <h6>Date of Arrival</h6>
            <DatePicker
              label=""
              className="bg-white"
              value={formValues.dateOfArrival}
              onChange={(date) => handleChange("dateOfArrival", date)}
              slotProps={{ textField: { fullWidth: true } }}
            />
          </Grid>

          <Grid item xs={12} md={4} sm={6}>
          <h6>To Time</h6>
            <TimePicker
              label=""
              className="bg-white"
              value={formValues.toTime}
              onChange={(time) => handleChange("toTime", time)}
              views={["minutes", "seconds"]}
              format="mm:ss"
              ampm={false}
              slotProps={{ textField: { fullWidth: true } }}
            />
          </Grid>

        

          

          <Grid item xs={12} sm={6} md={4}>
          <h6>To Country</h6>
            <FormControl fullWidth variant="outlined">
              <Autocomplete
                aria-placeholder="to Country"
                className="bg-white"
                id="countryName"
                value={
                  toCountryName.find(
                    (option) => option.value === formValues.toCurrentLocationId?.toString()
                  ) || null
                }
                options={toCountryName}
                getOptionLabel={(option) => option.label}
                onChange={(event, newValue) =>
                  handleSelectToCountryChange(event, newValue)
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label=""
                    placeholder="to Country"
                  />
                )}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
          <h6>To Region</h6>
            <FormControl fullWidth variant="outlined">
              <Autocomplete
                aria-placeholder="to Region"
                className="bg-white"
                id="toRegions"
                value={
                  toRegions.find(
                    (option) => option.value === formValues.toRegionId?.toString()
                  ) || null
                }
                options={toRegions}
                getOptionLabel={(option) => option.label}
                onChange={(event, newValue) =>
                  handleSelectToRegionChange(event, newValue)
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label=""
                    placeholder="to Region"
                  />
                )}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
          <h6>To Project</h6>
            <FormControl fullWidth variant="outlined">
              <Autocomplete
                aria-placeholder="Select a Project"
                className="bg-white"
                id="toproject"
                value={{
                  label: formValues.toProjectName ?? "", 
                  value: formValues.toProjectId?.toString() ?? "", 
                }}
                options={toproject}
                getOptionLabel={(option) => option.label}
                onChange={(event, newValue) =>
                  handleSelectToProjectChange(event, newValue)
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    className="bg-white"
                    variant="outlined" // 👈 This gives the box style
                    label=""
                    placeholder="Select a project"
                  />
                )}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
          <h6>To Supplier</h6>
            <FormControl fullWidth variant="outlined">
              <Autocomplete
                aria-placeholder="Select a Supplier"
                className="bg-white"
                id="toSupplier"
                value={{
                  label: formValues.toSupplierName ?? "", 
                  value: formValues.toSupplierId?.toString() ?? "", 
                }}
                options={toSupplier}
                getOptionLabel={(option) => option.label}
                onChange={(event, newValue) =>
                  handleSelectToSupplierChange(event, newValue)
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    className="bg-white"
                    variant="outlined" // 👈 This gives the box style
                    label=""
                    placeholder="Select a supplier"
                  />
                )}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
              />
            </FormControl>
          </Grid>
           
          </Grid>
        </Box>

       <Box
          sx={{
            borderRadius: 2,
            boxShadow: 3,
            padding: 2,
            backgroundColor: "#FFFFFF",
            border: "12px solid #F9F9F9",
            marginBottom: 3,
          }}
          component="form"
        >
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <h5>Details</h5>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <h6>Item Description</h6>
              <TextField
                label=""
                fullWidth
                className="bg-white"
                value={formValues.itemDescription}
                onChange={(e) => handleChange("itemDescription", e.target.value)}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <h6>Transport</h6>
                <FormControl fullWidth variant="outlined">
                  <Autocomplete
                    aria-placeholder="transport"
                    className="bg-white"
                    id="transport"
                    value={{
                      label: formValues.transportName, 
                      value: formValues.transportId?.toString() ?? "", 
                    }}
                    options={transport}
                    getOptionLabel={(option) => option.label}
                    onChange={(event, newValue) =>
                      handleSelectTransportChange(
                        { target: { value: newValue } },
                        "transportName",
                        "transportId"
                      )
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined" // 👈 This gives the box style
                        label=""
                        placeholder="transport"
                      />
                    )}
                    isOptionEqualToValue={(option, value) =>
                      option.value === value.value
                    }
                  />
                </FormControl>
             </Grid>

             <Grid item xs={12} sm={6} md={4}>
              <h6>Transporter</h6>
                <FormControl fullWidth variant="outlined">
                  <Autocomplete
                    aria-placeholder="transporter"
                    className="bg-white"
                    id="transporter"
                    value={{
                      label: formValues.transporterName, 
                      value: formValues.transporterId?.toString() ?? "", 
                    }}
                    options={transporter}
                    getOptionLabel={(option) => option.label}
                    onChange={(event, newValue) =>
                      handleSelectTransporterChange(
                        { target: { value: newValue } },
                        "transporterName",
                        "transporterId"
                      )
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined" // 👈 This gives the box style
                        label=""
                        placeholder="transporter"
                      />
                    )}
                    isOptionEqualToValue={(option, value) =>
                      option.value === value.value
                    }
                  />
                </FormControl>
             </Grid>

             <Grid item xs={12} sm={6} md={4}>
              <h6>Cost Allocation</h6>
                <FormControl fullWidth variant="outlined">
                  <Autocomplete
                    aria-placeholder="costAllocation"
                    className="bg-white"
                    id="costAllocation"
                    value={{
                      label: formValues.costAllocationName, 
                      value: formValues.costAllocationId?.toString() ?? "", 
                    }}
                    options={costAllocation}
                    getOptionLabel={(option) => option.label}
                    onChange={(event, newValue) =>
                      handleSelectCostAllocationChange(
                        { target: { value: newValue } },
                        "costAllocationName",
                        "costAllocationId"
                      )
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined" // 👈 This gives the box style
                        label=""
                        placeholder="costAllocation"
                      />
                    )}
                    isOptionEqualToValue={(option, value) =>
                      option.value === value.value
                    }
                  />
                </FormControl>
             </Grid>

             <Grid item xs={12} sm={6} md={4}>
              <h6>Cost Allocation Details</h6>
              <TextField
                label=""
                fullWidth
                className="bg-white"
                value={formValues.costAllocationDetails}
                onChange={(e) => handleChange("costAllocationDetails", e.target.value)}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <h6>PURCHASE ORDER No</h6>
              <TextField
                label=""
                fullWidth
                className="bg-white"
                value={formValues.others1}
                onChange={(e) => handleChange("others1", e.target.value)}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <h6>Quotation/Invoice No</h6>
              <TextField
                label=""
                fullWidth
                className="bg-white"
                value={formValues.others2}
                onChange={(e) => handleChange("others2", e.target.value)}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <h6>Others 3</h6>
              <TextField
                label=""
                fullWidth
                className="bg-white"
                value={formValues.others3}
                onChange={(e) => handleChange("others3", e.target.value)}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
                <h6>Attach Files</h6>
                  <FormControl fullWidth>
                    {/* <InputLabel shrink htmlFor="fileUpload">Attach Files</InputLabel> */}
                    <Input
                      id="fileUpload"
                      type="file"
                      className="bg-white"
                      inputProps={{ multiple: true, accept: ".pdf, .xls, .xlsx" }}
                      onChange={handleFileUpload}
                      style={{ fontSize: "14px" }}
                    />
                  </FormControl>
      
                    {
                    formValues?.attachments && formValues?.attachments.length > 0 && (
                      <List sx={{ width: "100%", bgcolor: "background.paper", p: 2 }}>
                        {formValues.attachments.map((file, index) => (
                          <ListItem 
                            key={index} 
                            sx={{
                              display: "flex", 
                              flexDirection: { xs: "column", sm: "row" }, // Stacks on small screens
                              alignItems: "center",
                              justifyContent: "space-between",
                              gap: 2,
                              borderBottom: "1px solid #ddd",
                              pb: 1,
                              mb: 1,
                            }}
                          >
                            {/* File Name */}
      
                            {/* Action Buttons */}
                            <Box display="flex" justifyContent={"space-between"} gap={1}>
                              {/* <Typography variant="body1" 
                                // sx={{ flexGrow: 1, wordBreak: "break-word" }}
                              > */}
                                {file.name}
                                <DownloadIcon
                                  titleAccess="Download"
                                  onClick={() => {
                                    const fileUrl = `${FILE_DOWNLOAD_PREVIEW + file.attachmentId}`;
                                    const link = document.createElement("a");
                                    link.href = fileUrl;
                                    link.setAttribute("download", ""); // Ensures download behavior
                                    document.body.appendChild(link);
                                    link.click();
                                    document.body.removeChild(link);
                                  }}
                                  color="primary"
                                />
                              <CloseIcon
                                color="error"
                                onClick={() => removeFile(index)}
                                titleAccess="Remove"
                              />
                              {/* </Typography> */}
                            </Box>
                          </ListItem>
                        ))}
                      </List>
                    )
                  }
                </Grid>

           <Grid item xs={12} sm={6} md={3}>
            <h6>Comments</h6>
            <Box
              component="textarea"
              placeholder="Write your comments here..."
              value={formValues.comments}
              onChange={(e) => handleChange("comments", e.target.value)}
              rows={5}
              sx={{width: "100%"}}
            />
          </Grid>
            

          </Grid>
        </Box>

         <Grid item xs={12}>
          <Box textAlign="right">
            <Box sx={{ display: "flex", justifyContent: "flex-end", marginTop: 2 }}>
              <Button 
                type="button"               // ⛔ Prevent form submission
                onClick={handleClear}
                color="secondary"
                variant="outlined"
                className="btn btn-secondary text-white"
              >
                Cancel
              </Button>

               {userDetails.role.some(
                  r => r.roleName === "Admin" || r.roleName === "Logistics Write"
                ) && (

              <Button
                type="button"              // ✅ Use this if you're handling submit manually
                onClick={handleSubmit}
                color="primary"
                variant="contained"
                className="btn btn-primary text-white w120"
                style={{ marginLeft: 8 }}
              >
                Submit
              </Button>
                )}
            </Box>
          </Box>
        </Grid>
        
      {/* </Paper> */}
      </div>
      </form>
    </LocalizationProvider>
  );
};

export default CreateIndent;

